/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-16 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';

type Props = WithI18nProps;

class RecentlyViewedTab extends Component<Props, State> {
  render() {
    const { recentlyViewedEnable, i18n } = this.props;
    return (
      <FormLayout>
        <div>
          <Field
            name="recentlyViewed.recentlyViewedEnable"
            component={RenderCheckbox}
            label={i18n.translate(
              'AdminHTML.DefaultLayoutSettings.RecentlyViewedTab.outerField_Label'
            )}
          />
          {recentlyViewedEnable && (
            <div className="groupFields">
              <Field
                name="recentlyViewed.limit"
                component={RenderTextField}
                type="number"
                label={i18n.translate(
                  'AdminHTML.DefaultLayoutSettings.Common.limit'
                )}
                tooltip={i18n.translate(
                  'AdminHTML.DefaultLayoutSettings.RecentlyViewedTab.innerField1_Tooltip'
                )}
              />
              <Field
                name="recentlyViewed.recentProductSliderRange"
                component={RenderTextField}
                label={i18n.translate(
                  'AdminHTML.DefaultLayoutSettings.Common.productSliderRange'
                )}
                type="number"
                tooltip={i18n.translate(
                  'AdminHTML.DefaultLayoutSettings.Common.numberOfProductShownPerRange'
                )}
              />
            </div>
          )}
        </div>
      </FormLayout>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formDefaultLayoutSettings = getFormValues('DefaultLayoutSettingsForm')(state);
  const recentlyViewedEnable = _.get(
    formDefaultLayoutSettings,
    'recentlyViewed.recentlyViewedEnable',
    false
  );
  return {
    recentlyViewedEnable
  };
};

export default connect(mapStateToProps)(withI18n()(RecentlyViewedTab));
